import React from 'react';
import './LoadingScreen.css';


const LoadingScreen = () => {
  // const [state, setState] = useState(null);


  return (
    <div className="LoadingScreen">
    </div>
  );
};

export default LoadingScreen;
